module.exports = __webpack_public_path__ + "img/tile-ene1.38bba3fe.jpg";